import React from 'react';

import { CurrencyIcon } from '@pkg/components';
import { type BaseCurrencyType } from '@pkg/types';

import { ArrowChangeLabel } from '@app/pages/NFTDetailView/components/ArrowChangeLabel';

import {
    DetailInner,
    DetailsBottomLabel,
    DetailsItem,
    DetailsTopLabel,
    TimeLabel,
    TimeWrapper,
    Value,
    ValuePrefix,
    ValueText,
} from './styles';

interface Props {
    topLabel: string;
    value: string;
    bottomLabel?: string;
    changePercent?: number;
    timeLabel?: string;
    currency?: BaseCurrencyType;
    truncate?: boolean;
}

export const Detail = ({
    topLabel,
    value,
    bottomLabel,
    changePercent,
    timeLabel,
    currency,
    truncate = false,
}: Props) => {
    const currencyMarkup =
        !currency || currency === 'usd' ? null : (
            <ValuePrefix>
                <CurrencyIcon currency={currency} theme="dark" />
            </ValuePrefix>
        );

    return (
        <DetailsItem>
            <DetailsTopLabel>{topLabel}</DetailsTopLabel>

            <DetailInner>
                <Value>
                    {currencyMarkup}
                    <ValueText $truncate={truncate}>{value}</ValueText>
                </Value>

                {(changePercent || timeLabel) && (
                    <TimeWrapper>
                        {changePercent && (changePercent > 0.1 || changePercent < -0.1) && (
                            <ArrowChangeLabel value={changePercent} size={11} />
                        )}

                        {timeLabel && <TimeLabel>{timeLabel}</TimeLabel>}
                    </TimeWrapper>
                )}

                {bottomLabel ? <DetailsBottomLabel>{bottomLabel}</DetailsBottomLabel> : null}
            </DetailInner>
        </DetailsItem>
    );
};
